import { isSet, oneSet } from 'rise-ui/utils/nullish.js';

/**
 * @name DrawOptions
 * @property {number} [paddingTop] (default: 0)
 * @property {number} [paddingLeft] (default: 0)
 * @property {number} [paddingRight] (default: 0)
 * @property {number} [paddingBottom] (default: 0)
 * @property {number} [padding] Shortcut for all other padding (default: 0)
 * @property {number} [fontSize]
 * @property {string} [fontFamily] (default: sans-serif)
 * @property {string} [font] Alias to fontFamily
 * @property {string} [fontFace] Alias to fontFamily
 * @property {string} [fontColor]
 * @property {number} [fontMultiplier]
 */

export function parseDrawOptions(options) {
  options = options || {};
  Object.assign(options, {
    paddingTop: options.paddingTop || options.padding || 0,
    paddingLeft: options.paddingLeft || options.padding || 0,
    paddingRight: options.paddingRight || options.padding || 0,
    paddingBottom: options.paddingBottom || options.padding || 0,
    fontFamily: options.fontFamily || options.fontFace || options.font || 'sans-serif',
    fontSize: isSet(options.fontSize) ? options.fontSize : 10,
    fontMultiplier: oneSet(options.fontMultiplier, 1),
    lineHeight: options.lineHeight || 1,
    transform: typeof options.transform === 'function' ? options.transform : d => d,
  });
  return options;
}
